<script lang="ts">
  let { name, size = 28 }: { name: string | null; size?: number } = $props();
  const initials = $derived.by(() => {
    if (!name) return '?';
    const parts = name.split(' ').filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
    return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  });
</script>

<div
  class="grid place-items-center rounded-full font-semibold text-white shrink-0 ring-1 ring-black/5"
  style="width:{size}px; height:{size}px; font-size:{Math.round(size * 0.4)}px; background: linear-gradient(135deg, var(--color-pu), var(--color-pu-2)); box-shadow: inset 0 1px 0 rgba(255,255,255,0.18);"
>{initials}</div>
